import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Table, TableBody, TableRow, TableCell, Link as MuiLink } from "@material-ui/core";

const CardProduct = ({ productForm, forms }) => {
  const [showPreviewImg, setShowPreviewImg] = useState(false);

  useEffect(() => {
    if (productForm.imgFile) {
      setShowPreviewImg(true);
    } else {
      setShowPreviewImg(false);
    }
  }, [productForm.imgFile]);

  const findFormtypeLabel = (type) => {
    const result = forms.find((item) => item.value === type);
    return result ? result.label : "不明な入力方法";
  };

  const showQuestionRequire = (value) => (value ? "ON" : "OFF");

  return (
    <Box>
      <Card>
        {showPreviewImg && (
          <Box display="flex" justifyContent="center">
            <img
              src={productForm.imgPreview}
              alt="商品画像のプレビュー"
              style={{ maxWidth: "80%" }}
              onError={() => setShowPreviewImg(false)}
            />
          </Box>
        )}
        <CardContent>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>商品名</TableCell>
                <TableCell>{productForm.title}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>価格</TableCell>
                <TableCell>{parseInt(productForm.rawPrice, 10).toLocaleString()} 円</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>商品の説明</TableCell>
                <TableCell className="textbox">{productForm.description}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>商品URL</TableCell>
                <TableCell>
                  {productForm.URL.map((url, index) =>
                    url ? (
                      <MuiLink href={url} target="_blank" key={index}>
                        {url}
                      </MuiLink>
                    ) : null
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>メール文面</TableCell>
                <TableCell className="textbox">{productForm.mailtext}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>備考</TableCell>
                <TableCell className="textbox">{productForm.note}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      {productForm.questions.map((question, index) => (
        <Card key={index} className="my-4">
          <CardContent>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>質問</TableCell>
                  <TableCell>{question.formLabel}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>入力方法</TableCell>
                  <TableCell>{findFormtypeLabel(question.formtype)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>必須</TableCell>
                  <TableCell>{showQuestionRequire(question.questionRequire)}</TableCell>
                </TableRow>
                {question.choises.map((choice, choiseIndex) => (
                  choice && (
                    <TableRow key={choiseIndex}>
                      <TableCell>選択肢</TableCell>
                      <TableCell>{choice}</TableCell>
                    </TableRow>
                  )
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default CardProduct;